import * as React from 'react'
import type { SVGProps } from 'react'
const SvgWhatsapp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.5169 13.9846c-.2482-.1231-1.4667-.7221-1.6923-.8051-.2277-.0821-.3928-.1231-.558.123-.1651.2493-.64.8062-.7846.9713-.1436.1662-.2882.1867-.5364.0616-.2482-.1231-1.0461-.3846-1.9918-1.2277-.7364-.6564-1.2338-1.4677-1.3784-1.7159-.1436-.2482-.0154-.3816.1087-.5057.1118-.1107.2482-.2892.3713-.4338.1241-.1436.1661-.2472.2482-.4133.082-.1641.041-.3098-.0205-.4339-.0616-.123-.558-1.3425-.7641-1.838-.201-.482-.4052-.4174-.557-.4256a10 10 0 0 0-.4748-.0082.91.91 0 0 0-.6605.3098C7.6 7.8913 6.96 8.4903 6.96 9.7087s.8872 2.3969 1.0113 2.5621c.123.1651 1.7466 2.6666 4.2307 3.7384.5918.2564 1.0534.4082 1.4123.5221.5939.1887 1.1344.162 1.5611.0984.4759-.0718 1.4646-.599 1.6718-1.1774.2061-.5785.2061-1.0749.1435-1.1785-.0615-.1025-.2256-.1641-.4738-.2892m-4.52 6.1702h-.0031a8.23 8.23 0 0 1-4.1948-1.1487l-.3006-.1784-3.1179.8174.8318-3.039-.1949-.3118a8.216 8.216 0 0 1-1.2605-4.3835C3.759 7.3692 7.4554 3.6738 12 3.6738c2.201 0 4.2697.8585 5.8256 2.4154a8.186 8.186 0 0 1 2.4103 5.8277c-.0011 4.5426-3.6975 8.2379-8.239 8.2379m7.0123-15.2481A9.852 9.852 0 0 0 11.9969 2c-5.4646 0-9.9118 4.4451-9.9148 9.9097 0 1.7467.4553 3.4523 1.323 4.9539L2 22l5.2554-1.3785a9.91 9.91 0 0 0 4.7384 1.2072h.0031c5.4636 0 9.9118-4.4462 9.9138-9.9108a9.85 9.85 0 0 0-2.9015-7.0112"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgWhatsapp
